import { render, staticRenderFns } from "./OpinionTypeEdit.vue?vue&type=template&id=9ee8ed5a&scoped=true"
import script from "./OpinionTypeEdit.vue?vue&type=script&lang=js"
export * from "./OpinionTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee8ed5a",
  null
  
)

export default component.exports